import React from 'react'
import css from './style.scss'
import {connect} from 'react-redux';
import StoriesGroup from './stories_group'
import {withRouter, Route} from 'react-router-dom';
import cn from 'classnames'
import api from '../api';
import StoryDetails from 'components/account_page/story_details/containers/story';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment'
import Button from 'components/shared/button/index';
import store from 'utils/store'
import AdventureBar from './adventure/adventure_bar'

const Loading=(props)=>{
  return (
    <div className={cn(css.noStories, css.loading)}>
      <h4 className={css.title}>Loading...</h4>
    </div>
  )
}

const EndStories=(props)=>{
  if(props.stories.length>0){
    return (
      <div className={cn(css.noStories, css.endStories)}>
        <h4 className={css.title}>You reached the end.</h4>
        <p>Go make some new stories!</p>
        {props.isOnFreePlan && moment(props.account_created_at) < moment().subtract(7,"days") &&
          <div className={css.free_plan}>
            <p>We are displaying only your stories of the last 7 days. <br/>Upgrade now to access all your stories!</p>
            <Button primary onClick={()=>{store.dispatch({type:"OPEN_PREMIUM_MODAL"})}}>Upgrade now</Button>
          </div>
        }
      </div>
    )
  }else{
    return (
      <div className={css.noStories}>
        <h4 className={css.title}>Searching for stories...</h4>
        <p>If you posted any story on Instagram in the last 24 hours,<br/> we are processing them and they will appear here soon.
        <br/><br/>
        <b>No stories?</b> Go make some right now!</p>
      </div>
    )
  }

}

class StoriesSection extends React.Component{
  constructor(props){
    super(props)
    this.state={
      hasMore:true,
      loading:false,
      adventureDialog:(props.location.state && props.location.state.adventureDialog) || false,
      adventureProps: (props.location.state && props.location.state.adventure),
      adventureStories:(props.location.state && props.location.state.adventure && props.location.state.adventure.stories) || []
    }
  }
  componentDidMount(){
    this.loadStories(0)
  }
  getStories(filters={}){
    api.getStories(this.props.account, filters).then((results)=>{
      this.setState({loading:false})
    })
  }
  handleDatesChange(startDate, endDate){
    this.getStories()
  }
  loadStories(page){
    this.setState({loading:true})
    let startDate=moment().subtract((6*page)+6, "days")
    let endDate=moment().subtract(6*page, "days")
    let filters={
      startDate:startDate.format("YYYY-MM-DD"),
      endDate:endDate.format("YYYY-MM-DD")
    }
    this.getStories(filters)
    if(!this.props.account.all_access){
      this.setState({hasMore:false, loading:false})
    }else{
      if(endDate < moment(this.props.account.created_at)){
        this.setState({hasMore:false})
      }
    }
  }
  createAdventure = () => {
    this.setState({adventureDialog:true})
  }
  onAdventureClose = () => {
    this.setState({adventureDialog:false, adventureStories:[]})
  }
  onAdventureCheck = (story_id, selected) => {
    let stories=[...this.state.adventureStories]
    if(selected){
      stories.push(this.props.stories.find(s=>s.id===story_id))
    }else{
      stories=stories.filter(s=>s.id!==story_id).sort((a,b)=>b.timestamp-a.timestamp)
    }
    stories=stories.sort((b,a)=>moment(b.posted_at).toDate()-moment(a.posted_at).toDate())
    this.setState({adventureStories: stories})
  }
  render(){
    return (
      <div>
        <div className={css.head}>
          <h3>Your Stories</h3>
          <Button className={css.exportButton} onClick={this.createAdventure}>New Adventure</Button>
        </div>
        {this.state.adventureDialog && <AdventureBar onClose={this.onAdventureClose} account={this.props.account} adventure={this.state.adventureProps} stories={this.state.adventureStories}/>}
        <InfiniteScroll
          threshold={1200}
          pageStart={0}
          hasMore={!this.state.loading && this.state.hasMore}
          loadMore={this.loadStories.bind(this)}
          loader={<Loading/>}
        >
          <StoriesGroup
            adventureDialog={this.state.adventureDialog}
            selectedAdventures={this.state.adventureStories}
            onAdventureCheck={this.onAdventureCheck}
            onDatesChange={this.handleDatesChange.bind(this)}
            className={cn(css.storiesList, css.storiesListCalendar)}
            groupedStories={this.props.groupedStories}
          />
        </InfiniteScroll>
        <Route path="/a/:id/:storyId" render={routeProps=>(
          <StoryDetails {...routeProps}
          stories={this.props.stories}
          returnTo={"/a/"+this.props.account.id} />
        )} />
        {this.state.loading && <Loading/>}
        {!this.state.hasMore && <EndStories account_created_at={this.props.account.created_at} isOnFreePlan={!this.props.account.all_access} stories={this.props.stories}/>}
      </div>
    )
  }
}

const mapStateToProps = function (state, props) {
  let account=state.accounts[props.match.params.id]
  const groupStories=(stories)=>{
    let out=stories.reduce((acc, story)=>{
      let dat=moment(story.posted_at).startOf("day").format("MM-DD-YYYY")
      acc[dat] = acc[dat] || []
      acc[dat].push(story)
      return acc;
    }, {})
    return Object.keys(out).map(key=> {
      return {date:key,timestamp:moment(key).unix(), stories:out[key]}
    }).sort((a,b)=>b.timestamp-a.timestamp)
  }
  let stories=(account.stories||[]).reduce((acc,id)=>{
    if(state.stories[id]){acc.push(state.stories[id])}
    return acc;
  },[])
  let groupedStories=groupStories(stories)
  return {
    account,
    user:state.user.userData,
    stories:stories,
    groupedStories:groupedStories,
  };
}

export default connect(mapStateToProps)(withRouter(StoriesSection));



// WEBPACK FOOTER //
// ./src/components/account_page/stories/index.js